import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './feature.css'
import { 
  faClock, 
  faMapMarkerAlt, 
  faBell, 
  faEye,
  faTasks,
  faRocket
} from '@fortawesome/free-solid-svg-icons';

const SwiftBoardFeatures = () => {
  const [, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Add scroll animation for feature items
    const handleScroll = () => {
      const elements = document.querySelectorAll('.swift_feature-item');
      elements.forEach(el => {
        const elementTop = el.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (elementTop < windowHeight - 100) {
          el.classList.add('swift_animate');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const featuresData = [
    {
      icon: faTasks,
      title: "Centralized Bid Management",
      description: "Manage all your bids in one place, whether sourced from any bid portal or directly from clients.",
      color: "#4e54c8"
    },
    {
      icon: faClock,
      title: "Timeline Tracking",
      description: "Track your estimates with real-time progress monitoring and deadline management.",
      color: "#ff7e5f"
    },
    {
      icon: faBell,
      title: "Smart Notifications",
      description: "Get notified about bid due dates - a day before, 2 hours prior, and 30 minutes in advance.",
      color: "#feb47b"
    },
    {
      icon: faEye,
      title: "Project History Access",
      description: "Access and review any previous project estimates anytime with complete historical data.",
      color: "#2c9c69"
    },
    {
      icon: faMapMarkerAlt,
      title: "Location Intelligence",
      description: "Check bid locations directly via integrated Google Maps for better project planning.",
      color: "#6a11cb"
    },
    {
      icon: faRocket,
      title: "Swift Operations",
      description: "Experience faster bid processing and estimation with our optimized workflow system.",
      color: "#2575fc"
    }
  ];

  return (
    <div className="swift_features">
      {/* Light theme animated background elements */}
      <div className="swift_animated-bg">
        <div className="swift_bg-circle swift_bg-circle-1"></div>
        <div className="swift_bg-circle swift_bg-circle-2"></div>
        <div className="swift_bg-dots swift_bg-dots-1"></div>
        <div className="swift_bg-dots swift_bg-dots-2"></div>
      </div>
      
      <div className="swift_header">
        <h2 className="swift_title">
          Swift Board <span className="swift_accent">Features</span>
        </h2>
        <p className="swift_subtitle">
          Track your estimates on time and manage your bidding process efficiently with our powerful dashboard
        </p>
      </div>
      
      <div className="swift_feature-grid">
        {featuresData.map((feature, index) => (
          <div 
            key={index}
            className="swift_feature-item"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="swift_feature-card">
              <div className="swift_feature-icon-container" style={{ background: `linear-gradient(135deg, ${feature.color}15, ${feature.color}25)` }}>
                <FontAwesomeIcon 
                  className="swift_feature-icon" 
                  icon={feature.icon} 
                  style={{ color: feature.color }} 
                />
                <div className="swift_icon-pulse" style={{ backgroundColor: `${feature.color}20` }}></div>
              </div>
              <h3 className="swift_feature-title">{feature.title}</h3>
              <p className="swift_feature-desc">{feature.description}</p>
              <div className="swift_feature-hover-effect" style={{ background: `linear-gradient(135deg, ${feature.color}15, transparent)` }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SwiftBoardFeatures;